import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '@mui/material/styles';

import PageContainer from '../../../../components/layout/page-container/PageContainer';
import { useRegisterPageContainerError } from '../../../../components/layout/page-container/page-container-error-handler';
import UsersListBig from '../../../../components/reusable/users-list/UsersListBig';
import withRouter from '../../../../hoc/with-router';
import { useNotFound } from '../../../../hooks/useNotFound';
import { useGetCommunity } from '../../../../redux/api/communitiesApi';
import { useGetMyDetails } from '../../../../redux/api/users/usersApi';
import { useStyles } from './CommunityRequests.styles';

function CommunityRequests(props) {
  const { params } = props;
  const { t } = useTranslation();
  const {
    data: community,
    isFetching: isFetchingCommunity,
    isError: isCommunityError,
    error: communityError,
    refetch,
  } = useGetCommunity(params.communityId);
  const pageDataOwners = useMemo(
    () => ({
      community: community ?? null,
    }),
    [community],
  );
  const { data: user } = useGetMyDetails();
  const theme = useTheme();
  const { classes } = useStyles(theme);
  useNotFound(
    !isFetchingCommunity && pageDataOwners.community?.ownerId !== user?.id,
  );

  const handleRetry = useCallback(() => {
    void refetch();
  }, [refetch]);
  useRegisterPageContainerError({
    errors: communityError ? [communityError] : [],
    isLoading: isFetchingCommunity && pageDataOwners.community === undefined,
    hasData: Boolean(pageDataOwners.community),
    onRetry: handleRetry,
  });

  return (
    <PageContainer
      title={t('communities.communityRequests')}
      backButton
      onRefresh={() => void refetch()}>
      <div className={classes.requestsWrapper}>
        <UsersListBig
          users={
            pageDataOwners.community === undefined
              ? undefined
              : (pageDataOwners.community.requests ?? [])
          }
          communityId={pageDataOwners.community?.id}
          withoutTabs
          showSearch
          isLoading={
            isFetchingCommunity && pageDataOwners.community === undefined
          }
          isError={isCommunityError}
        />
      </div>
    </PageContainer>
  );
}

export default withRouter(CommunityRequests);
